module.exports = __webpack_public_path__ + "img/Minh.a1e3dd68.jpeg";